import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import * as React from 'react';
export default {
  BlogMidCTA,
  React
};